import { mapControl } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import DropMarker from '@/lib/map-control/marker/DropMarker';
import StoreMarker from '@/lib/map-control/marker/StoreMarker';
import WorkerMarker from '@/lib/map-control/marker/WorkerMarker';
export default class MarkerCollection {
    _items;
    mapControl = mapControl;
    naver;
    mapInstance;
    hubControlMap;
    bounds;
    vuexStore;
    mapControlState;
    markerMapper;
    // eslint-disable-next-line class-methods-use-this
    clickCallback = () => { };
    // eslint-disable-next-line class-methods-use-this
    mouseEnterLineCallback = () => { };
    // eslint-disable-next-line class-methods-use-this
    mouseLeaveLineCallback = () => { };
    constructor(naver, hubControlMap) {
        this.vuexStore = getGlobalStore();
        this.mapControlState = this.vuexStore.state.mapControl;
        this.naver = naver;
        this.hubControlMap = hubControlMap;
        this.mapInstance = hubControlMap.mapInstance;
        this.bounds = hubControlMap.bounds;
        this._items = {};
        this.markerMapper = {
            [mapControl.marker.DROP]: DropMarker,
            [mapControl.marker.STORE]: StoreMarker,
            [mapControl.marker.WORKER]: WorkerMarker,
        };
    }
    get items() {
        return this._items;
    }
    setClickCallback(callback) {
        this.clickCallback = callback;
    }
    setMouseEnterLineCallback(callback) {
        this.mouseEnterLineCallback = callback;
    }
    setMouseLeaveLineCallback(callback) {
        this.mouseLeaveLineCallback = callback;
    }
    /**
     * 마커 생성
     * @param markerType
     * @param markerData
     * @returns
     */
    createMarker(markerType, markerData) {
        const markerWrapper = new this.markerMapper[markerType](markerData, this.naver, this.hubControlMap);
        const naverMarker = new this.naver.maps.Marker(markerWrapper);
        return markerWrapper.init(naverMarker);
    }
    forEach(callback) {
        Object.values(this.items).forEach(callback);
    }
    /**
     * 마커 조회
     * @param id 마커 아이디
     * @returns
     */
    getMarker(id) {
        if (!id) {
            return undefined;
        }
        return this.items[id];
    }
    /**
     * 마커 추가
     */
    add(id, marker) {
        this.items[id] = marker;
    }
    /**
     * 특정 마커 제거
     * @param id 마커 아이디
     */
    deleteMarker(id) {
        const marker = this.getMarker(id);
        if (marker) {
            marker.setMap(null);
            delete this.items[id];
        }
    }
}
